'use client';

import { useInvestorQuery } from '@/hooks/use-investor-query';
import { fetchInvestorFees } from '../api/get-investor-fees';
import { portfolioKeys } from '@/lib/investor-keys';
import { SLOW_CADENCE_MS } from '../api/keys';
import type { InvestorMetricWindow } from '@/lib/investor-analytics';
import type { InvestorFeesResponse } from '../types/api';

export function useInvestorFees(
  params: { window?: InvestorMetricWindow } = {}
) {
  return useInvestorQuery<InvestorFeesResponse>({
    key: ({ address, chainId }) =>
      portfolioKeys.fees(address, chainId, params.window),
    fetch: ({ address, chainId }, signal) =>
      fetchInvestorFees(address, chainId, params, signal),
    // A window aggregate moves with the daily valuation, not by the minute.
    // Polling it every 60s only added to a page that already fans out, and
    // the rate limiter is a hard budget shared by every screen.
    cadenceMs: SLOW_CADENCE_MS
  });
}
